function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.6 3.413a1.36 1.36 0 0 0-1.924 0L12 10.075 5.324 3.4a1.36 1.36 0 0 0-1.925 0 1.36 1.36 0 0 0 0 1.925L10.075 12 3.4 18.676a1.36 1.36 0 0 0 0 1.925 1.36 1.36 0 0 0 1.925 0L12 13.925l6.676 6.676a1.36 1.36 0 0 0 1.925 0 1.36 1.36 0 0 0 0-1.925L13.925 12 20.6 5.324a1.368 1.368 0 0 0 0-1.911z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/close.a917a43c.svg";
export { SvgComponent as ReactComponent };